import { createActions } from 'redux-actions';
export const ADD_VOUCHER = 'ADD_VOUCHER';
export const REMOVE_VOUCHER = 'REMOVE_VOUCHER';
export const SET_VOUCHER = 'SET_VOUCHER';
export const { removeVoucher, setVoucher } = createActions({
    [REMOVE_VOUCHER]: () => { },
    [SET_VOUCHER]: (voucher) => voucher
});
